// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"245d9b1c","165":"b7b2f6dc","167":"c77b1314","221":"b3346e30","288":"7ea9b06a","507":"ae2b528e","523":"4029230a","561":"7a90c340","574":"93213603","748":"47bd78f8","785":"0f3fa6e4","821":"89848f77","968":"97388f7e","989":"c075102a","991":"1f49aecf"}[chunkId] + ".chunk.js";
};